<nz-card nzTitle="Toy safety report" [nzExtra]="headerExtra">
  <ng-container *ngIf="state$ | async as state">
    <nz-result
      *ngIf="state.error as errorMsg; else resultTpl"
      [nzIcon]="'meh-twotone'"
      nzTitle="An error occurred"
      [nzSubTitle]="errorMsg"
    ></nz-result>

    <ng-template #resultTpl>
      <nz-skeleton [nzActive]="true" [nzLoading]="(isDesignLoading$ | async) ?? false">
        <nz-table
          #tsrTable
          [nzData]="state.reports"
          [nzLoading]="state.loading"
          nzSize="small"
          [nzFrontPagination]="false"
        >
          <thead>
            <tr>
              <th>Name</th>
              <th>Status</th>
              <th>Material</th>
            </tr>
          </thead>
          <tbody class="em-no-table-row-hover">
            <tr *ngFor="let tsr of tsrTable.data; trackBy: trackByRef">
              <td>
                <a target="_blank" rel="external" [href]="tsr.webUrl">
                  {{ tsr.name }}
                </a>
              </td>
              <td><em-display-property [value]="tsr.status"></em-display-property></td>
              <td><em-display-property [value]="tsr.material.join(', ')"></em-display-property></td>
            </tr>
          </tbody>
        </nz-table>
      </nz-skeleton>
    </ng-template>
  </ng-container>

  <ng-template #headerExtra>
    <a target="_blank" rel="external" [href]="toySafetyUrl">
      <i nz-icon nzType="link"></i>
      Visit Toy Safety Report Tool
    </a>
    <a target="_blank" rel="external" [href]="siteUrl">
      <i nz-icon nzType="link"></i>
      SharePoint site
    </a>
  </ng-template>
</nz-card>
